import React, { useCallback, useEffect, useState, useContext } from "react";
import { LoginFormContext, LoginFormContextType } from "../utils";
import { useTranslation } from "react-i18next";
import { Modal, Spin } from "antd";
import { ReloadOutlined, ExclamationCircleFilled } from "@/utils/antdIcon";
import {
  IconSwitch,
  IconRight,
  IconTopUp
} from "@/components/icon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { AuthDataRes, BizTypeEnum } from "@/types/LoginPage";
import { changeSingleDomain } from "@/utils/tools";
import { BackNav } from "../comps";
import styles from "../index.module.less";
import styles1 from "./index.module.less"

function Avatar(params:any) {
  const { url, name } = params
  let text = name ? name.substring(0, 1) : 'M';
  return (
      <div style={{ position: 'relative' }}>
          <div className={styles["public-avatar"]}>
              {url ? (
                  <img className={styles["img-avatar"]} src={changeSingleDomain(url, "")} alt="avatar" />
              ) : (
                  <div className={styles["text-avatar"]}>{text}</div>
              )}
          </div>
          <div
              style={{
                  position: 'absolute',
                  bottom: 0,
                  color: '#fff',
                  fontSize: '10px',
                  background: '#ED6A0C',
                  width: 48,
                  height: 16,
                  borderRadius: '0 0 6px 6px',
                  textAlign: 'center'
              }}
          >
              公共账号
          </div>
      </div>
  );
}

function PublicUserCard({
  item,
  clickHandle
}:{
  item: any;
  clickHandle: () => void;
}) {
  return (
    (
      <div
        key={item.userId}
        style={{
          padding: "12px 16px",
          marginBottom: "16px",
          borderRadius: "6px",
          boxShadow: "0px 8px 20px 0px rgba(0,0,0,0.1)",
          cursor: 'pointer'
        }}
        onClick={clickHandle}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              width: 280,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ paddingRight: 16, float: 'left' }}>
              <Avatar name={item.realName} url={item.headImg} />
            </div>
            <div>
                <div style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '216px'
                }}>
                    <span
                        style={{
                            color: '#232930',
                            fontSize: '16px'
                        }}
                    >
                        {item.realName}
                    </span>
                    <span
                        style={{
                            fontSize: '12px',
                            color: '#666666',
                            marginLeft: 6,
                            textAlign: 'right'
                        }}
                    >
                        @{item.teamFullName || item.teamShortName || ""}
                    </span>
                </div>
                <div
                    style={{
                        color: '#666',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {item.currentUser ? (
                        <>
                            <span
                                style={{
                                    width: 10,
                                    height: 10,
                                    background: '#00A645',
                                    borderRadius: '5px',
                                    display: 'inline-block',
                                    marginRight: '5px'
                                }}
                            />
                            <span>
                                {item.currentUser}&nbsp;已登录
                            </span>
                        </>
                    ) : (
                        <>
                            <span
                                style={{
                                    width: 10,
                                    height: 10,
                                    background: '#BFC1C4',
                                    borderRadius: '5px',
                                    display: 'inline-block',
                                    marginRight: '5px'
                                }}
                            />
                            <span>无使用人登录</span>
                        </>
                    )}
                </div>
            </div>
          </div>
          {IconRight}
        </div>
      </div>
    )
  )
}

export default function SelectPublicAccountForm({
  userTicketData,
  onTicketLoginSuccess
}: {
  userTicketData: AuthDataRes;
  onTicketLoginSuccess: (data: any) => void;
}) {
  const { navigate, onMobileChange, setResendLastTs, authInfo } = useContext<
    LoginFormContextType
  >(LoginFormContext);
  const { onGlobalError: onLoginError, service } = useContext<GlobalContextConfig>(GlobalContext);
  const { t } = useTranslation("common");
  const [toggle, setToggle] = useState(true);
  const [tipVisible, setTipVisible] = useState(false)
  const [publicUserList, setPublicUserList]: any = useState([])
  const [publicPlusUserList, setPublicPlusUserList]: any = useState([])
  const [listLoading, setListLoading] = useState(false);
  const [currentLoginName, setCurrentLoginName]: any = useState("")
  const [responsibleUserName, setResponsibleUserName] = useState("")

  useEffect(() => {
    const { publicAccountList } = userTicketData
    if (!toggle) {
      // setPublicUserList([..._publicUserList]);
    } else {
      const _publicUserList = publicAccountList ? publicAccountList : []
      if (_publicUserList.length <= 3) {
        setPublicUserList(_publicUserList);
      } else {
        setPublicUserList(_publicUserList.slice(0, 3));
        setPublicPlusUserList(_publicUserList.slice(3))
      }
    }
  }, [toggle])

  // useEffect(() => {
  //   if (currentLoginName) {
  //     setTipVisible(true)
  //   }
  // }, [currentLoginName])

  const onCancel = () => {
    setTipVisible(false)
  }

  const refreshPublicList = useCallback(async() => {
    setListLoading(true)
    const res = await service.authService.getPublicAccountList({
      userId: userTicketData.userId,
      ticket: userTicketData.ticket
    })
    const { publicAccountList = [] } = res || {}
    const _publicUserList = publicAccountList ? publicAccountList : []
    if (_publicUserList.length <= 3) {
      setPublicUserList(_publicUserList);
    } else {
      setPublicUserList(_publicUserList.slice(0, 3));
      setPublicPlusUserList(_publicUserList.slice(3))
    }
    setListLoading(false)
  }, [userTicketData])

  const handlePublicLogin = useCallback((item) => {
    if (item.currentUser && item.currentUserId !== userTicketData.userId) {
      // setCurrentLoginName(item.currentUser)
      // setResponsibleUserName(item.responsibleUser)
      // setTipVisible(true)
      Modal.confirm({
        title: '公共账号使用提醒',
        icon: <ExclamationCircleFilled style={{ marginRight: '8px', color: '#ED6A0C' }} />,
        content: (
            <div style={{ fontSize: 14 }}>
                <p style={{ color: '#666' }}>
                    同一时间仅允许1位用户使用公共账号。“{item.currentUser}
                    ”使用中，若需使用账号，有以下2种方式：
                </p>
                <p style={{ color: '#8F959E' }}>
                    方式1：联系当前使用人“{item.currentUser}
                    ”，请其在移动端、桌面端、网页端退出公共账号。
                </p>
                <p style={{ color: '#8F959E' }}>
                    方式2：联系责任人“{item.responsibleUser}
                    ”，请其踢出当前使用人。
                </p>
            </div>
        ),
        cancelText: '取消',
        okText: '我知道了'
      });
      return;
    }
    onTicketLoginSuccess({
      ticket: userTicketData.ticket,
      userId: item.userId,
      usageUserId: userTicketData.userId,
      loginType: 'public',
      pubTeamId: item.teamId
    })
  }, [userTicketData])

  return (
    <div
      className={styles.mobileForm}
      style={{
        border: "1px solid rgba(240,243,243,1)",
        borderRadius: "6px",
        padding: 0
        // marginTop: "10px"
      }}
    >
      <div
        style={{
          // padding: "20px 30px 0 30px"
        }}
      >
        <BackNav
          clickHandle={() => {
            onMobileChange("");
            setResendLastTs(-1);
            setTimeout(() => {
              navigate("step1");
            }, 0);
          }}
          title={t("login.changeLogin")}
          subtitle={t("login.selPublicAccount")}
        />
        <div style={{ fontSize: 12, marginTop: '-8px', marginBottom: '26px', display: 'flex', alignItems: 'center' }}>
          <span style={{ color: '#666666', marginRight: 9 }}>
            已授权的账号，可选择进入
          </span>
          <p style={{cursor: 'pointer'}} onClick={refreshPublicList}>
            <ReloadOutlined style={{ color: '#1686FF', marginRight: 3 }} />
            <span style={{ color: '#1686FF' }}>刷新</span>
          </p>
        </div>
      </div>
      <div>
        <div className={styles.selectTeam}>
          <Spin spinning={listLoading}>
            <div className={styles.teamScroller}>
              {
                publicUserList.map((item: any, index: number) => {
                  return (
                    <PublicUserCard
                      item={item}
                      clickHandle={() => {
                        handlePublicLogin(item)
                      }}
                    />
                  )
                })
              }
              {
                !toggle && publicPlusUserList.map((item: any, index: number) => {
                  return (
                    <PublicUserCard
                      item={item}
                      clickHandle={() => {
                        handlePublicLogin(item)
                      }}
                    />
                  )
                })
              }
              {toggle && publicPlusUserList.length ? (
                <p
                  style={{
                    fontSize: "14px",
                    textAlign: "center",
                    marginTop: "32px",
                    cursor: "pointer"
                  }}
                  className={styles1["join-me-primary-color"]}
                  onClick={() => {
                    setToggle(false);
                  }}
                >
                  <span
                    style={{
                      marginRight: 6
                    }}
                  >
                    {t("login.togglePublicAccount", {
                      num: publicPlusUserList.length
                    })}
                  </span>
                  {IconTopUp}
                </p>
              ) : null}
            </div>
          </Spin>
        </div>
      </div>
      {/* <Modal
        width={457}
        title="公共账号使用提醒"
        visible={tipVisible}
        onCancel={onCancel}
        bodyStyle={{
          padding: '16px 50px'
        }}
        footer={[
          <Button onClick={onCancel}>取消</Button>,
          <Button onClick={onCancel} type="primary">我知道了</Button>
        ]}
      >
        <div style={{fontSize: 14}}>
          <p style={{color: '#666'}}>同一时间仅允许1位用户使用公共账号。“{currentLoginName}”使用中，若需使用账号，有以下2种方式：</p>
          <p style={{color: '#8F959E'}}>方式1：联系当前使用人“{currentLoginName}”，请其在移动端、桌面端、网页端退出公共账号。</p>
          <p style={{color: '#8F959E'}}>方式2：联系责任人“{responsibleUserName}”，请其踢出当前使用人。</p>
        </div>
      </Modal> */}
    </div>
  )
}
